import React, {
  FC, useState, useMemo, useEffect,
} from 'react'

import { useFormContext } from 'react-hook-form';
import _last from 'lodash/last';
import _times from 'lodash/times';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

import { selectDischargedPatientConfig } from 'reducers/DischargedPatients';
import { Select } from 'components/FormControls';

const Forbidden: FC<{ states: string[], readMode: boolean }> = ({ states, readMode }) => {
  const {
    control, errors, getValues,
  } = useFormContext();
  const config = useSelector(selectDischargedPatientConfig);
  const [rows, setRows] = useState<number[]>([0]);

  useEffect(() => {
    if (!config) {
      return;
    }
    setRows(_times(config.ConfigurationData?.StatusConfiguration?.Forbidden.length));
  }, [config, readMode]);

  const forbiddenOptions = useMemo(() => [
    '',
    '*',
    ...states,
  ].map((item) => ({
    label: item,
    value: item,
  })), [states]);

  return (
    <div>
      <h6 className="h6">
        Forbidden Transitions
      </h6>
      {rows.map((key, index) => (
        <Row className="align-items-center" key={key}>
          <Col>
            <Row>
              <Col className="pr-0" xs={6}>
                <Select
                  id={`Forbidden.${key}.TransitionFrom`}
                  name={`Forbidden.${key}.TransitionFrom`}
                  options={forbiddenOptions}
                  label="Transition From"
                  control={control}
                  defaultValue=""
                  rules={{
                    validate: (val: string) => {
                      const values = getValues();
                      if (!val && values.Forbidden?.[key]?.TransitionTo) {
                        return 'Transition From is required';
                      }

                      if (val !== '' && val !== '*' && values.Forbidden?.[key]?.TransitionTo === val) {
                        return 'Transition From can not be the same as Transition To'
                      }

                      return true;
                    },
                  }}
                  errors={errors.Forbidden?.[key]?.TransitionFrom?.message}
                  readOnly={readMode}
                />
              </Col>
              <Col className="pr-0" xs={6}>
                <Select
                  id={`Forbidden.${key}.TransitionTo`}
                  name={`Forbidden.${key}.TransitionTo`}
                  options={forbiddenOptions}
                  label="Transition To"
                  control={control}
                  defaultValue=""
                  rules={{
                    validate: (val: string) => {
                      const values = getValues();
                      if (!val && values.Forbidden?.[key]?.TransitionFrom) {
                        return 'Transition To is required';
                      }

                      if (val !== '' && val !== '*' && values.Forbidden?.[key]?.TransitionFrom === val) {
                        return 'Transition To can not be the same as Transition From'
                      }

                      return true;
                    },
                  }}
                  errors={errors.Forbidden?.[key]?.TransitionTo?.message}
                  readOnly={readMode}
                />
              </Col>
            </Row>
          </Col>
          <Col className="flex-grow-0" style={{ flexBasis: '45.75px', marginTop: '12px' }}>
            <FontAwesomeIcon
              icon="trash-alt"
              style={{
                cursor: (rows.length === 1 || readMode) ? 'default' : 'pointer',
                opacity: (rows.length === 1 || readMode) ? 0.5 : 1,
                fontSize: '18px',
              }}
              color={(rows.length === 1 || readMode) ? 'gray' : '#FF7052'}
              onClick={() => {
                if (rows.length === 1 || readMode) {
                  return;
                }
                setRows([
                  ...rows.slice(0, index),
                  ...rows.slice(index + 1),
                ]);
              }}
            />
          </Col>
        </Row>
      ))}
      <div className="d-flex justify-content-end">
        <FontAwesomeIcon
          icon={faPlusSquare}
          className="mb-3"
          color="#0F4CDB"
          size="2x"
          style={{
            cursor: readMode ? 'default' : 'pointer', fontSize: 24,
          }}
          onClick={() => {
            if (readMode) {
              return;
            }
            setRows([...rows, _last(rows) + 1]);
          }}
        />
      </div>
    </div>
  )
}

export default Forbidden;
